export default __webpack_public_path__ + "f8acf7fa661d59106d7eafb7710eef2c.png";